import { Controller } from "@hotwired/stimulus"

// Polls /gridsignal/scans/:id/status every 2s while a user-facing
// market scan is running. On completion, redirects straight to the
// jurisdiction detail page so the user lands on their result without
// having to click anything.
export default class MarketScanMonitorController extends Controller {
  static targets = ["statusBadge", "progressBar", "stageMessage", "docsDone", "docsTotal", "docsLabel", "previewCard", "previewSignals"]
  static values = { url: String, active: Boolean }

  connect() {
    if (this.activeValue) this.poll()
  }

  disconnect() {
    if (this._timer) clearTimeout(this._timer)
  }

  poll() {
    fetch(this.urlValue, { headers: { "Accept": "application/json" } })
      .then(r => r.json())
      .then(data => this.update(data))
      .catch(() => {})
      .finally(() => {
        if (this.activeValue) {
          this._timer = setTimeout(() => this.poll(), 2000)
        }
      })
  }

  update(data) {
    if (this.hasStatusBadgeTarget) {
      this.statusBadgeTarget.textContent = data.display_status || this.titleize(data.status)
      this.statusBadgeTarget.className = `gs-scan-status-badge gs-scan-status--${data.status}`
    }
    if (this.hasProgressBarTarget) {
      this.progressBarTarget.style.width = `${data.progress_percentage}%`
    }
    if (this.hasStageMessageTarget && data.stage_message) {
      this.stageMessageTarget.textContent = data.stage_message
    }
    if (this.hasDocsLabelTarget) {
      this.docsLabelTarget.textContent = (data.status === "ingesting" || data.status === "full_scanning")
        ? "Meetings scanned"
        : "Documents read"
    }
    if (this.hasDocsDoneTarget) this.docsDoneTarget.textContent = data.docs_done
    if (this.hasDocsTotalTarget) this.docsTotalTarget.textContent = data.docs_total

    // Preview card: unhide the moment phase 1 finishes, hide once
    // the full scan completes (that path shows the "See full
    // results" card instead).
    if (this.hasPreviewCardTarget) {
      const shouldShow = data.preview_ready && !data.completed_at
      this.previewCardTarget.hidden = !shouldShow
    }
    if (this.hasPreviewSignalsTarget && data.preview_signals_found != null) {
      this.previewSignalsTarget.textContent = data.preview_signals_found
    }

    // On terminal state: redirect to the jurisdiction page if we
    // have one (completed), else just reload so the view renders
    // the no_vendor / failed empty states.
    if (!data.active) {
      this.activeValue = false
      setTimeout(() => {
        if (data.status === "completed" && data.jurisdiction_path) {
          window.location.href = data.jurisdiction_path
        } else {
          window.location.reload()
        }
      }, 800)
    }
  }

  titleize(s) {
    if (!s) return ""
    return s.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())
  }
}
